import { Grid, Typography } from '@mui/material';
import { BindCard } from '@components/bindCard/BindCard';
import { SubjectivityTable } from '@components/Subjectivities/SubjectivityTable';
import * as styles from '@components/dataGrid/DataGrid.styles';

export type SubjectivitiesCardProps = {
  quoteNumber: string;
  quoteId: string;
};

export const SubjectivitiesText = {
  title: 'Subjectivities',
  description:
    'This quote has the following subjectivities. You have until the days specified to resolve each subjectivity post the effective date to avoid cancellation of this Policy.',
};

export const SubjectivitiesCard = ({ quoteId, quoteNumber }: SubjectivitiesCardProps) => {
  return (
    <BindCard>
      {[
        {
          title: SubjectivitiesText.title,
          content: (
            <>
              <Grid size={{ xs: 12 }}>
                <Typography variant='bodySmall' sx={{ color: 'text.secondary' }}>
                  {SubjectivitiesText.description}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <SubjectivityTable
                  variant='quote'
                  quoteId={quoteId}
                  transactionNumber={quoteNumber}
                  hidePagination
                  sxProps={{
                    tableContainer: { display: 'block', height: 'fit-content' },
                    dataGridContainer: {
                      borderLeft: 'none',
                      padding: 0,
                      height: 'auto',
                      // Target the dataGridBox wrapper to remove its background and fixed height
                      '& > div': {
                        backgroundColor: 'transparent !important',
                        borderRadius: 0,
                        height: 'auto !important',
                      },
                    },
                    dataGrid: {
                      ...styles.subjectivitiesDataGrid,
                      backgroundColor: 'transparent',
                      // Auto-height: let the grid expand to fit all rows without scrolling
                      height: 'auto !important',
                      '& .MuiDataGrid-main': { overflow: 'visible' },
                      '& .MuiDataGrid-virtualScroller': {
                        backgroundColor: 'transparent !important',
                        overflow: 'hidden',
                        height: 'auto !important',
                      },
                      '& .MuiDataGrid-virtualScrollerContent': { height: 'auto !important' },
                      '& .MuiDataGrid-virtualScrollerRenderZone': {
                        position: 'relative !important',
                        height: 'auto !important',
                      },
                      '& .MuiDataGrid-row:last-child': { borderBottomWidth: 0, borderBottomStyle: 'none' },
                    },
                  }}
                />
              </Grid>
            </>
          ),
        },
      ]}
    </BindCard>
  );
};
